import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css, keyframes } from "styled-components";
import { Container, Col, Row } from "../grid";
export const StyledRow = styled(Row) `
  height: 100%;
`;
export const StyledCol = styled.div `
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  min-width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  @media ${({ theme }) => theme.device.medium} {
    min-width: 50%;
    max-width: 75%;
    padding-right: 0.75rem;
    padding-left: 0.75rem;
  }
  @media ${({ theme }) => theme.device.large} {
    min-width: 33.33%;
    max-width: 50%;
  }
`;
export const StyledContainer = styled(Container) `
  height: 100%;
  max-width: var(--gdds-hero-image-max-width, none);
  margin: 0 auto;
`;
export const DesktopCol = styled((props) => _jsx(Col, Object.assign({}, props))) `
  display: none;

  @media ${({ theme }) => theme.device.medium} {
    display: block;
  }
`;
export const StyledHeroWrapper = styled.div `
  height: ${({ navigationHeight }) => `calc(100vh - ${navigationHeight}px);`};
  width: 100%;
  position: relative;
  overflow: hidden;

  button + div {
    margin: 0;
  }

  ${({ heroType }) => heroType === "b"
    ? `
      & > div > div ,
      & > div {
        height: 100%;
      }`
    : ""}
`;
export const Image = styled.div `
  all: unset;
  display: block;
  width: 100%;
  height: 100%;
  background-color: black;
  ${({ src }) => `background: url(${src});`}
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;
const fadeIn = keyframes `
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const fadeDown = keyframes `
  0% {
    transform: translate3d(0, -250%, 0);
  }

  30% {
    transform: translate3d(0, 30%, 0);
  }

  50% {
    transform: translate3d(0, -25%, 0);
  }

  70% {
    transform: translate3d(0, 20%, 0);
  }

  100% {
    transform: translate3d(0, 0%, 0);
  }
`;
const animationFadeIn = (duration) => css `${fadeIn} ${duration}s linear`;
const animationDown = css `
  ${animationFadeIn(1.5)}, ${fadeDown} 2s ease;
`;
export const IconText = styled.span `
  color: ${({ color }) => color};
  font-size: ${({ theme }) => theme.fontTokens.font11[0]};
  line-height: ${({ theme }) => theme.fontTokens.font11[1]};
  align-self: ${({ alignment }) => alignment};
  ${({ animation }) => animation
    ? css `
          animation: ${animationFadeIn(0.5)};
          animation-fill-mode: both;
          animation-delay: 3s;
        `
    : ""}
`;
export const StyledScrollIndicatorWrapper = styled.span `
  display: none;
  position: absolute;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 10;
  height: auto;

  @media ${({ theme }) => theme.device.medium} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  span:first-child {
    min-width: 3rem;
    text-align: center;
  }

  button {
    ${({ animation }) => animation
    ? css `
            animation: ${animationDown};
            opacity: 0;
            animation-fill-mode: both;
            animation-delay: 1.5s;
          `
    : ""}
  }

  span:last-child {
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
  }

  svg {
    width: 1.25rem;
  }
`;
export const ScrollToElement = styled.div `
  ${({ navigationHeight }) => `scroll-margin: ${navigationHeight}px;`}

  @media ${({ theme }) => theme.device.large} {
    ${({ navigationHeight }) => `scroll-margin: ${Math.trunc(navigationHeight / 2)}px;`}
  }
`;
